import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const Login = () => {
  const { login, user, loading } = useAuth();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const error = searchParams.get("error");

  useEffect(() => {
    // If user is already logged in, redirect to home
    if (user) {
      navigate("/");
    }
  }, [user, navigate]);

  if (loading) {
    return (
      <div>
        <div
          style={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div>Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: "xs" }}>
      <div
        style={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div style={{ p: 4, width: "100%", textAlign: "center" }}>
          <div component="h1" variant="h5" gutterBottom>
            Welcome to Chicago Jamaat Portal
          </div>

          {error && (
            <div color="error" sx={{ mb: 2 }}>
              {error === "access_denied"
                ? "Access denied. Please try again."
                : "An error occurred during login. Please try again."}
            </div>
          )}

          <button onClick={login}>Sign in with Chicago Jamaat</button>
        </div>
      </div>
    </div>
  );
};

export default Login;
